document.addEventListener('DOMContentLoaded', () => {
  const originalCta = document.getElementById('event-detail-cta-anchor');
  const stickyCta = document.querySelector('.event-detail__sticky-cta');

  if (!originalCta || !stickyCta) return;

  const anchor = stickyCta.querySelector('a');

  if (!anchor) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        stickyCta.classList.remove('event-detail__sticky-cta--visible');
        stickyCta.setAttribute('aria-hidden', 'true');
        anchor.setAttribute('tabindex', '-1');
      } else {
        stickyCta.classList.add('event-detail__sticky-cta--visible');
        stickyCta.setAttribute('aria-hidden', 'false');
        anchor.removeAttribute('tabindex');
      }
    });
  }, { threshold: 0 });

  observer.observe(originalCta);
});
